import { useVersionCheck } from '@/hooks/useVersionCheck';

/**
 * Monta el sondeo de versión. No pinta nada: el aviso sale como toast (sonner).
 */
export function VersionWatcher() {
  useVersionCheck();
  return null;
}
